<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="pd-10 bg-white mgb-30">
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="订单编号">
          <el-input
            v-model="form.orderNo"
            clearable
            placeholder="请输入订单编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="企业用户">
          <el-input
            v-model="form.companyName"
            clearable
            placeholder="请输入企业用户"
          ></el-input>
        </el-form-item>
        <el-form-item label="支付状态">
          <el-select v-model="form.status" clearable placeholder="全部">
            <el-option label="待支付" value="1"></el-option>
            <el-option label="已支付" value="2"></el-option>
            <el-option label="已到账" value="3"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-form :inline="true" ref="form" :model="form" label-width="80px">
        <el-form-item label="购卡时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="mgl-30">
          <el-button type="primary" @click="getList()">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      style="width: 100%"
      :cell-style="cellStayle"
    >
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>

      <el-table-column prop="orderNo" label="订单编号"> </el-table-column>
      <el-table-column prop="futureCompanyName" label="企业用户">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.futureCompanyName ? scope.row.futureCompanyName : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="comboName" label="套餐名称"> </el-table-column>
      <el-table-column prop="comboType" label="套餐类型"> </el-table-column>
      <el-table-column prop="status" label="支付状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.status === 1
                ? '待支付'
                : scope.row.status === 2
                ? '已支付'
                : scope.row.status === 3
                ? '已到账'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="支付金额"> </el-table-column>
      <el-table-column prop="cardNum" label="购卡数量"> </el-table-column>
      <el-table-column prop="createTime" label="购卡时间"> </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";

export default {
  components: {
    breadcrumbs,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      tableData: [],

      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 20, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      form: {},
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.sim
        .buyList({
          pageNum: this.page,
          pageSize: this.pageSize,
          orderNo: this.form.orderNo,
          futureCompanyName: this.form.companyName,
          status: this.form.status,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },

    // 根据条件判断字段颜色
    cellStayle(row, colum, rowIndex, columnIndex) {
      if (row.row.status === 2 && row.columnIndex == 5) {
        return "color:orange";
      } else if (row.row.status === 1 && row.columnIndex == 5) {
        return "color:red";
      } else if (row.row.status === 3 && row.columnIndex == 5) {
        return "color:green";
      } else {
        return;
      }
    },
    reset() {
      this.form = {};
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
